import { api } from "../api/api";
export const exportToExcel = async (url, filename, setLoading) => {
  try {
    setLoading(true)
    const response = await api.get(
      url + `export_to_xcl/?file_name=${filename.toLowerCase()}`,
      {
        responseType: "blob", // Ensure binary data is received correctly
      }
    );

    // Create a Blob from the response data
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a link element
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${filename}`; // Set the file name

    // Append link to body, trigger download, and remove link
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error exporting file:", error);
  } finally {
    setLoading(false)
  }
};
